import { render } from "./ProgressaoDescontos.vue?vue&type=template&id=9be289c6&scoped=true"
import script from "./ProgressaoDescontos.vue?vue&type=script&lang=js"
export * from "./ProgressaoDescontos.vue?vue&type=script&lang=js"

import "./ProgressaoDescontos.vue?vue&type=style&index=0&id=9be289c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9be289c6"]])

export default __exports__